module.exports = __webpack_public_path__ + "static/img/map_shanxi.f0003d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/join/map_shanxi.png
// module id = sWlN
// module chunks = 0